export default __webpack_public_path__ + "static/media/google-play-badge-en2.d8dba632.png";